import { type StyleProp, StyleSheet, type ViewStyle } from 'react-native';
import {
    classic,
    stringifyValueWithProperty,
} from 'react-native-web/dist/exports/StyleSheet/compiler';
import preprocess from 'react-native-web/dist/exports/StyleSheet/preprocess';
import hash from 'react-native-web/dist/vendor/hash';

import type { WebSpecificStyle } from '../theme';

export function convertStyleToCSS(
    style: StyleProp<ViewStyle> | StyleProp<WebSpecificStyle> | 'hidden' | 'visible'
): string;
export function convertStyleToCSS(style: StyleProp<ViewStyle> | 'hidden' | 'visible'): string;
/**
 * Generate a CSS string from react-native styles.
 */
export function convertStyleToCSS(
    style: StyleProp<ViewStyle> | StyleProp<WebSpecificStyle> | 'hidden' | 'visible'
): string {
    if (style === 'hidden') {
        return 'display: none;';
    }

    if (style === 'visible') {
        return 'display: flex;';
    }

    const css = classic(preprocess(StyleSheet.flatten(style)));
    const flattenedRules = css[1]
        .map(([rules]) => rules[0])
        .map((rule) => {
            return rule.replace(/^\.[^{]+{/, '').replace(/}$/, '');
        })
        .join(' ');

    return flattenedRules;
}

/**
 * Insert CSS rules into the DOM.
 */
export function insertCSSStyle(css: string, group: number): void {
    // @ts-ignore - StyleSheet.getSheet() is available through our patch
    StyleSheet.getSheet().sheet.insert(css, group);
}

/**
 * An identifier is associated with a unique set of styles.
 */
export function hashStyle(style: StyleProp<ViewStyle> | 'hidden' | 'visible'): string {
    if (style === undefined || style === null || style === false) {
        return '';
    }
    if (typeof style === 'string' || typeof style === 'number') {
        return `${style}`;
    }
    if (Array.isArray(style)) {
        return (style as Array<StyleProp<ViewStyle>>).map(hashStyle).join('-');
    }
    return Object.keys(style)
        .map((name) => {
            const hashedString = hash(name + stringifyValueWithProperty(style[name], name));
            return process.env.NODE_ENV !== 'production'
                ? `${name}-${hashedString}`
                : `${hashedString}`;
        })
        .join('-');
}
